export default __webpack_public_path__ + "static/media/conn.30f94550.gif";